var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.roles.length === 0 || ( _vm.roles.includes('Admin') || _vm.roles.includes('Editor')))?_c('router-view'):_vm._e(),(_vm.roles.length > 0 && ( !_vm.roles.includes('Admin') && !_vm.roles.includes('Editor')))?_c('guest-dashboard'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }